import React, { BaseSyntheticEvent, Component } from 'react';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { RuleEngineController } from '../../ruleEngine.Controller';
import CustomUIType,{ICustom} from './ui-type/custom';
import FileUIType, {IFile} from './ui-type/file';
import PickListUIType from './ui-type/picklist';
import ReferenceUIType,{IReference} from './ui-type/reference';
import { observer } from 'mobx-react';
import TemplateConfigurationController from '../../../template-config.controller';

type IPickList = string
type StateType = IFile | ICustom | IReference | IPickList;
type IProps = {
    selectedTemplateName: string,
    selectedObject: string, 
    selectedLayout: string,
    fieldName: string
}

const selectOption :{value: string, display: string}[] = [
    {value: 'reference', display: 'Reference'},
    {value: 'file', display: 'File'},
    {value: 'custom', display: 'Custom'},
    {value: 'picklist', display: 'Picklist'},
    {value: 'polymorphic', display: 'Polymorphic'}
];
/**
 * Renders UI Type Selection Component
 * @class ApplyUITypeSource
 */
class ApplyUITypeSource extends Component<IProps, any> {
    private readonly ruleEngineController: RuleEngineController;
    constructor(props: IProps){
        super(props);
        this.ruleEngineController = new RuleEngineController();
        this.state = {
            showAddButton: true,
            canSave: false,
            obj: null,
        }
    }

    componentDidMount() {
        const templateStore = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
        const uiType: StateType =
            templateStore.uiType[this.props.fieldName] ||
            templateStore.picklistValueSource[this.props.fieldName];
        if(uiType) {
            this.setState({
                obj: { [this.props.fieldName]: uiType }
            });
        }
        const showAddButton = uiType ? false : true;
        this.setState({showAddButton});
    }

    /**
     * Update realted value of the state based in the User input value
     * Update realted value of the state based in the User input value
     * @function onSelectChange
     * @param { BaseSyntheticEvent } e Event from the different input elements
     * @memberof ApplyUITypeSource
     */

    onSelectChange = (e: BaseSyntheticEvent) => {
        const { value } = e.target;
        let tempObj: any;
        if(value ==='custom'){
            tempObj = {
                [this.props.fieldName]: {
                    type: 'custom',
                    componentName: ''
                }
            }
        } else if(value ==='file'){
            tempObj = {
                [this.props.fieldName]: {
                    type: 'file',
                    showFilePicker: false
                }
            }

        } else if(value === 'reference') {
            tempObj = {
                [this.props.fieldName]: {
                    type: 'reference',
                    apiName: '',
                    objLayoutFieldsArray: []
                }
            }
        } else if(value === 'polymorphic') {
            tempObj = {
                [this.props.fieldName]: {
                    type: 'polymorphic',
                }
            }
            this.setState({ canSave: true });
        } else {
            tempObj = {
                [this.props.fieldName]: ""
            }
        }

        this.setState({obj: tempObj});
    }

    onChangeHandler = (stateCopy: StateType) => {
        this.setState({
            obj: {
            [this.props.fieldName]: stateCopy
            }
        });
        this.canSaveHandler()
    }

    updateStore = (sourceValueName: string,uitype: string,uitypeRule: any) => {
        const uiType = this.state.obj;
        if (!uiType) {
          return;
        }
        CQMasterDataStore.RuleElements.setRuleElementObject(this.props.fieldName, sourceValueName,uitype);
        uiType.hasOwnProperty(this.props.fieldName) &&
        sourceValueName === "PicklistValueSource"
          ? this.ruleEngineController.setPickListvalueSource(this.props.selectedTemplateName,uitypeRule)
          : sourceValueName === "LookupFilter"
          ? CQMasterDataStore.OutputConfig.setlookupFilters(this.props.selectedTemplateName,this.props.fieldName, uitypeRule)
          : this.ruleEngineController.setUITypeSource(this.props.selectedTemplateName,uitypeRule);
      };
    
    /**
     * Saves the uiType to field
     * @function onSaveHandler
     * @returns Updates Property Value
     * @memberof ApplyUITypeSource
     */

    onSaveHandler = () => {
        const uiType = this.state.obj;
        if (!uiType) {
            return;
        }

        if (uiType[this.props.fieldName].hasOwnProperty('category')) {
            //Save in picklist
            const picklist: string = uiType[this.props.fieldName].category;
            this.updateStore('PicklistValueSource', uiType, picklist);
            this.ruleEngineController.deleteUITypeValueSource(this.props.selectedTemplateName);

        } else {
            const type = this.state.obj[this.props.fieldName].type
            const apiName = this.state.obj[this.props.fieldName].apiName

            //Save in UIType
            if (type === 'reference') {
                //save in UIType Reference Lookup Filter
                let objLayoutFieldsArray = this.state.obj[this.props.fieldName].objLayoutFieldsArray;
                const uiTypeRuleProperty = {
                    type,
                    apiName,
                }
                objLayoutFieldsArray = this.arrayHandler(objLayoutFieldsArray);
                if (objLayoutFieldsArray.length > 0) {
                    //Save LookupFilters
                    this.updateStore( 'LookupFilter', objLayoutFieldsArray, { 'fields': objLayoutFieldsArray });
                } else {
                    //Delete LookupFilters
                    CQMasterDataStore.RuleElements.deleteAppliedRule(this.props.selectedTemplateName, this.props.fieldName, 'LookupFilter');
                    CQMasterDataStore.OutputConfig.deleteRule(this.props.selectedTemplateName, this.props.fieldName, 'fields', 'lookupFilters');
                }
                //Save in UIType Reference Object apiName
                this.updateStore('UITypeValueSource',uiType[this.props.fieldName], uiTypeRuleProperty);
            } else if(type === 'polymorphic'){
                //Save in UIType Polymorphic
                this.updateStore('UITypeValueSource', uiType[this.props.fieldName] , {type:'polymorphic'});
            } else {
                //Delete LookupFilter if present
                CQMasterDataStore.RuleElements.deleteAppliedRule(this.props.selectedTemplateName, this.props.fieldName, 'LookupFilter');
                CQMasterDataStore.OutputConfig.deleteRule(this.props.selectedTemplateName, this.props.fieldName, 'fields', 'lookupFilters');

                //Save in UIType File/Custom
                this.updateStore('UITypeValueSource',uiType[this.props.fieldName],uiType[this.props.fieldName]);                
            }
            this.ruleEngineController.deletePicklistValueSource(this.props.selectedTemplateName);
        }
        this.setState({ canSave: false });
    }

    arrayHandler = (arr: []) => {
        let resultArray: [] = [];
        if (arr !== undefined) {
            arr.map(data => {
                if (data !== '') {
                    resultArray.push(data);
                }
            });
            return resultArray;
        } else {
            return ''
        }
    }

    /**
     * Used to Delete in Uitype
     * @function onDeleteHandler
     * @memberof ApplyUITypeSource
     */

    onDeleteHandler = () => {
        const uiType = this.state.obj;

        this.setState({ showAddButton: true, canSave: false});
        if(!uiType) {
            return;
        }
        //delete in picklist and Uitype
        this.ruleEngineController.deletePicklistValueSource(this.props.selectedTemplateName);
        this.ruleEngineController.deleteUITypeValueSource(this.props.selectedTemplateName);
        this.setState({ obj: {} });
    }

    /**
     * Used to get UiType value
     * @function getUIType
     * @memberof ApplyUITypeSource
     */

    getUIType = () => {
        const uiType = this.state.obj;
        if (!uiType) {
            return;
        }

        const data = uiType[this.props.fieldName];
        if (typeof data === 'string') {
            return 'picklist';
        }else if (data === undefined){
            return ''
        }else{
            return data.type;
        }
        
    }

    /**
     * Reads the saved triggering fields for the current field.
     * Templates published before the lookup filter shape was corrected store the
     * fields as a bare array instead of { fields: [...] }, so both are supported from this.
     * @function getSavedTriggeringFields
     * @returns Saved triggering fields, empty when none are usable
     * @memberof ApplyUITypeSource
     */

    getSavedTriggeringFields = (lookupFilters: any) => {
        const savedLookupFilter = lookupFilters[this.props.fieldName];
        if (Array.isArray(savedLookupFilter?.fields)) {
            return [...savedLookupFilter.fields];
        }
        if (Array.isArray(savedLookupFilter)) {
            return [...savedLookupFilter];
        }
        return [];
    }

    /**
     * Used to render component accorinding to specific type
     * @function result
     * @returns Components specific to type
     * @memberof ApplyUITypeSource
     */

    renderInput = () => {
        const outputConfig = CQMasterDataStore.OutputConfig;
        const { picklistValueSource, lookupFilters } = outputConfig.getStoreData(this.props.selectedTemplateName);
        switch (this.getUIType()) {
            case 'picklist':
                return <PickListUIType
                      type='picklist'  
                      category={
                          !this.state.obj[this.props.fieldName].category
                          ?
                            picklistValueSource[this.props.fieldName]
                          : 
                            this.state.obj[this.props.fieldName].category
                      }
                      onPicklistChange={this.onChangeHandler}
                />;

            case 'file':
                return <FileUIType
                    showFilePicker={this.state.obj[this.props.fieldName].showFilePicker}
                    shareContent={this.state.obj[this.props.fieldName].shareContent}
                    onFileChange={this.onChangeHandler}
                />;

            case 'custom':
                return <CustomUIType
                    type ='custom'
                    componentName={this.state.obj[this.props.fieldName].componentName}
                    onCustomChange={this.onChangeHandler}
                />;

            case 'reference':
                return (
                  <ReferenceUIType
                    type="reference"
                    selectedTemplateName={this.props.selectedTemplateName}
                    onReferenceChange={this.onChangeHandler}
                    apiName={this.state.obj[this.props.fieldName].apiName}
                    objLayoutFieldsArray={
                      this.state.obj[this.props.fieldName].objLayoutFieldsArray === undefined
                        ? this.getSavedTriggeringFields(lookupFilters)
                        :[...this.state.obj[this.props.fieldName]
                            .objLayoutFieldsArray]
                    }
                    loadTriggeringField={
                      this.state.obj[this.props.fieldName].loadTriggeringField
                    }
                  />
                );
            case 'polymorphic':
                return <></>;

            default:
                return <div>Please enter valid UI Type</div>
        }
    }

    /**
     * Used to identify whether or not to activate save button
     * @function canSaveHandler
     * @memberof ApplyUITypeSource
     */

    canSaveHandler = () => {
        let obj = this.state.obj;

        if (!obj) {
            this.setState({ canSave: false });
            return;
        }

        const uiType = obj[this.props.fieldName];
        if (uiType === 'reference' && obj.apiName !== '') {
            this.setState({ canSave: true });
        } else if (uiType === 'file') {
            this.setState({ canSave: true });
        } else if (uiType === 'custom' && obj.componentName !== '') {
            this.setState({ canSave: true });
        } else if (uiType === '') {
            this.setState({ canSave: true });
        } else {
            this.setState({ canSave: true });
        }
    }

    componentDidUpdate() {
        const fieldRuleElement: any = { ...CQMasterDataStore.RuleElements.FieldRuleElement[this.props.fieldName] };
        if (this.state.obj !== null) {
            let uiTypeValue = fieldRuleElement.hasOwnProperty("UITypeValueSource") ?
                { ...fieldRuleElement["UITypeValueSource"] } : { ...fieldRuleElement["PicklistValueSource"] };
            if (((fieldRuleElement.hasOwnProperty("UITypeValueSource") ||
                fieldRuleElement.hasOwnProperty("PicklistValueSource"))) &&
                !this.state.obj.hasOwnProperty(this.props.fieldName)) {

                if (fieldRuleElement.hasOwnProperty("PicklistValueSource")) {
                    const type = uiTypeValue[this.props.fieldName].type
                    const category = uiTypeValue[this.props.fieldName].category
                    uiTypeValue = {
                        type,
                        category,
                    }
                }
                this.setState({
                    showAddButton: uiTypeValue? false:true,
                    obj: {
                        [this.props.fieldName]: uiTypeValue
                    }
                });
            }
        }
    }

    render() {
        if (this.state.showAddButton) {
            return (<div>
                <button
                    className="slds-button slds-button_brand"
                    onClick={() => this.setState({ showAddButton: false })}
                >
                    Add UI Type
                </button>
            </div>)
        }

        return (
            <div className="slds-form-element" role="content-uiType">
                <label className="slds-form-element__label" htmlFor="type">UI Type: </label>
                <div className="slds-form-element__control">
                    <div className="slds-select_container">
                        <select
                            name="type"
                            id="type"
                            role="select-uiType"
                            className="slds-select"
                            required
                            onChange={this.onSelectChange}
                            value={this.getUIType()}
                        >
                            <option value="">Please select</option>
                            {selectOption &&
                                selectOption.map((data: { value: string, display: string }, key) => {
                                    return (
                                        <option value={data.value} key={key}> {data.display} </option>
                                    );
                                })}
                        </select>
                    </div>
                    {
                        this.renderInput()
                    }
                    <div className="slds-grid slds-grid_align-spread slds-m-vertical_small">
                        <p> <button
                            className="slds-button slds-button_brand"
                            onClick={this.onSaveHandler}
                            disabled={!this.state.canSave}
                        >
                            Save
                        </button></p>
                        <button
                            className="slds-button slds-button_neutral"
                            onClick={this.onDeleteHandler}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export const ApplyUIType = observer(ApplyUITypeSource);